import {useState} from 'react';
import {twx} from '@/utils/tailwindUtils';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
    fallback?: React.ReactNode;
};

const Image = ({fallback = null, className, alt, onError, ...rest}: ImageProps) => {
    const [hasError, setHasError] = useState(false);

    if (hasError) return <>{fallback}</>;

    return (
        <img
            alt={alt ?? ''}
            className={twx(className)}
            onError={(e) => {
                setHasError(true);
                onError?.(e);
            }}
            {...rest}
        />
    );
};

export default Image;
